import { buildDsmImageProps } from '@/aem-dsm-mappers/utils/imageProps';
import { Box, Typography } from '@kohler-dsm-library/kohler-core';

const FeatureCard = ({ card, isActive, isHovered, onClick, onHover }) => {
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => onHover(card.id)}
      onMouseLeave={() => onHover(null)}
      tabIndex={0}
      role="button"
    >
      {/* IMAGE */}
      <div className="card-imageWrapper">
        <img
          {...buildDsmImageProps({
            src: card.image,
            alt: card.title,
            allowEmptySrc: true,
          })}
        />
        <span className="card-label">{card.id}</span>
      </div>

      {/* CONTENT */}
      <Box className="card-content">
        <Typography size="label-medium-m" component="p" className="title">
          {card.title}
        </Typography>
        <Typography size="paragraph-small" component="p" className="description">
          {card.description}
        </Typography>
        {card.cta && card.link && (
          <Typography
            size="button-s"
            component="a"
            href={card.link}
            style={{ textDecoration: 'underline' }}
            className="cta"
          >
            {card.cta}
          </Typography>
        )}
      </Box>
    </div>
  );
};

export default FeatureCard;
